import type { Dimensions } from "@xyflow/react";

export enum GraphLayout {
  TopDown = "TopDown",
  BottomUp = "BottomUp",
  LeftRight = "LeftRight",
  RightLeft = "RightLeft",
  Indented = "Indented",
}

export type GraphDirection = "DOWN" | "UP" | "LEFT" | "RIGHT";

export const layoutDirection: Record<GraphLayout, GraphDirection | undefined> = {
  [GraphLayout.TopDown]: "DOWN",
  [GraphLayout.BottomUp]: "UP",
  [GraphLayout.LeftRight]: "RIGHT",
  [GraphLayout.RightLeft]: "LEFT",
  [GraphLayout.Indented]: undefined,
};

export const oppositeDirection: Record<GraphDirection, GraphDirection> = {
  DOWN: "UP",
  UP: "DOWN",
  LEFT: "RIGHT",
  RIGHT: "LEFT",
};

const DEFAULT_DIRECTION: GraphDirection = "DOWN";

export const graphDirection = (layout: GraphLayout): GraphDirection =>
  layoutDirection[layout] ?? DEFAULT_DIRECTION;

export type NodeSize = Dimensions;

export type PageFormat = "a4" | "square" | "slide";

export const pageSize: Record<PageFormat, Dimensions> = {
  a4: { width: 794, height: 1123 },
  square: { width: 1000, height: 1000 },
  slide: { width: 1600, height: 900 },
};
